<h2 mat-dialog-title>
  Create your own Analysis
</h2>

<mat-dialog-content>

  <mat-stepper #stepper (selectedIndexChange)="selectionChange($event)">
    <mat-step [hasError]="introPageSelected && hasErrorName()" errorMessage="You need to define a name">
      <ng-template matStepLabel>Introduction</ng-template>
      <div class="stepper-btn-group align-end">
        <button mat-button matStepperNext (click)="introPageSelected=true">
          <div class="next-btn">
            <span>Next</span>
            <mat-icon>arrow_forward_ios</mat-icon>
          </div>
        </button>
      </div>


      <p>
        You can create a overview of your founded papers here.
      </p>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput placeholder="My analysis" [(ngModel)]="name" required/>
      </mat-form-field>

      <p>First you need to select papers, you can select only these which have a pdf.</p>
      <p>You can also select tone, length and accuracy of the summary</p>
      <p>After that you can start the summarization process.</p>
    </mat-step>
    <mat-step [hasError]="papersPageSelected && hasErrorPapers()" errorMessage="You need to select at least one paper">
      <ng-template matStepLabel>Select your papers</ng-template>
      <div class="stepper-btn-group">
        <button mat-button matStepperPrevious>
          <mat-icon>arrow_back_ios</mat-icon>
          Back
        </button>
        <button mat-button matStepperNext (click)="papersPageSelected=true">
          <div class="next-btn">
            <span>Next</span>
            <mat-icon>arrow_forward_ios</mat-icon>
          </div>
        </button>
      </div>
      <app-research-paper-list
        [projectId]="data.projectId"
        [filters]="papersFilter"
        [disablePapersDialog]="true"
        [isSelectList]="true"
        [fixedAppliedFilters]="fixedAppliedFilters"
        (itemsSelected)="selectedPapers = $event"
      ></app-research-paper-list>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>How a summary should be written</ng-template>

      <div class="stepper-btn-group">
        <button mat-button matStepperPrevious>
          <mat-icon>arrow_back_ios</mat-icon>
          Back
        </button>
        <button mat-button [disabled]="hasError()" (click)="createSummary()">Create</button>
      </div>
      <div class="slider-group">
        <div class="slider-wrapper">
          <span class="slider-title">
            <strong>Select writing style: </strong>
          </span>
          <mat-button-toggle-group
            name="tone"
            aria-label="Language Ton"
            [(ngModel)]="selectedTone"
            [hideSingleSelectionIndicator]="false"
          >
            @for (availableTone of availableTones; track $index) {
              <mat-button-toggle [value]="availableTone.enum">{{ availableTone.label }}</mat-button-toggle>
            }
          </mat-button-toggle-group>
          <span class="slider-hint">
           {{ getLabelTone() }}
          </span>
        </div>
        <div class="slider-wrapper">
          <span class="slider-title">
            <strong>Select summary length: </strong>
          </span>
          <mat-button-toggle-group
            name="tone"
            aria-label="Language Ton"
            [(ngModel)]="selectedLength"
            [hideSingleSelectionIndicator]="false"
          >
            @for (av of availableLength; track $index) {
              <mat-button-toggle [value]="av.enum">{{ av.label }}</mat-button-toggle>
            }
          </mat-button-toggle-group>
          <span class="slider-hint">
           {{ getLabelLength() }}
          </span>
        </div>
        `<!--<div class="slider-wrapper">
          <span class="slider-title">
            <strong>Select summary accuracy: </strong>
          </span>
          <mat-button-toggle-group
            name="tone"
            aria-label="Language Accuracy"
            [(ngModel)]="selectedAccuracy"
            [hideSingleSelectionIndicator]="false"
          >
            @for (av of availableAccuracy; track $index) {
              <mat-button-toggle [value]="av.enum">{{ av.label }}</mat-button-toggle>
            }
          </mat-button-toggle-group>
          <span class="slider-hint">
           {{ getLabelAccuracy() }}
          </span>
        </div> -->
      </div>
    </mat-step>
  </mat-stepper>


</mat-dialog-content>

<mat-dialog-actions class="actions">
  <button mat-button (click)="close()">Cancel</button>
</mat-dialog-actions>
